import ZoomOverlay from './ZoomOverlayContainer';

export default ZoomOverlay;
